import { useCallback, useEffect, useRef } from "react";

interface UseConversationInfiniteScrollProps {
  conversationsPage: number;
  conversationsTotal: number;
  conversationsLimit: number;
  setConversationsPage: (page: number) => void;
}

export const useConversationInfiniteScroll = ({
  conversationsPage,
  conversationsTotal,
  conversationsLimit,
  setConversationsPage,
}: UseConversationInfiniteScrollProps) => {
  const conversationListRef = useRef<HTMLDivElement>(null);

  const handleScroll = useCallback(
    (event: Event) => {
      const target = event.currentTarget as HTMLDivElement;
      const { scrollTop, scrollHeight, clientHeight } = target;
      const scrollThreshold = 10;

      if (scrollTop + clientHeight >= scrollHeight - scrollThreshold) {
        const totalPages = Math.ceil(conversationsTotal / conversationsLimit);
        if (conversationsPage < totalPages) {
          setConversationsPage(conversationsPage + 1);
        }
      }
    },
    [conversationsPage, conversationsTotal, conversationsLimit, setConversationsPage]
  );

  useEffect(() => {
    const currentConversationListRef = conversationListRef.current;
    if (currentConversationListRef) {
      currentConversationListRef.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (currentConversationListRef) {
        currentConversationListRef.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  return { conversationListRef };
};

